<div #trigger (click)="openDropdown(trigger, profileMenu)" class="tw:flex tw:items-center tw:gap-2 tw:cursor-pointer">
	<div class="tw:hidden tw:md:block">
		<div class="tw:font-semibold">{{ user.name | titlecase }}</div>
		<div class="tw:font-medium tw:text-end tw:text-secondary">{{ user.role?.name | titlecase }}</div>
	</div>
	@if (user.avatar) {
		<img class="tw:rounded-full" [src]="user.avatar" width="40" height="40" alt="" />
	} @else {
		<app-avatar-initials [name]="user.name" [width]="40" [height]="40" />
	}
	<div class="tw:p-2 tw:text-secondary! tw:hidden tw:md:block">
		@if (isOpen) {
			<mat-icon>stat_1</mat-icon>
		} @else {
			<mat-icon>stat_minus_1</mat-icon>
		}
	</div>
</div>
<ng-template #profileMenu>
	<app-topbar-user-profile-menu (click)="closeOverlay()" />
</ng-template>
